import type {
  IDecimalValueAndUnit,
  IDocument,
  IHaulageJobFormCreate,
  IHaulageJobRequestFormCreate
} from '@/interfaces'
import PriceWithUnit from '../PriceWithUnit'

class HaulageJobRequestFormCreate implements IHaulageJobRequestFormCreate {
  description: string | null
  customerId: string | null
  wasteCollectionProviderId: string | null
  requestDates: string[] | null
  price: IDecimalValueAndUnit | null
  purchaseOrderDocuments: IDocument[]
  purchaseOrderNumber: string | null
  assignedEmployeeId: string | null
  assignedVehicleId: string | null
  assignedEquipmentId: string | null

  constructor(jobData?: IHaulageJobFormCreate) {
    this.description = jobData?.description ?? null
    this.customerId = jobData?.customerId ?? null
    this.wasteCollectionProviderId = jobData?.wasteCollectionProviderId ?? null
    this.requestDates = jobData?.requestDates ?? null
    this.price = new PriceWithUnit(jobData?.price)
    this.purchaseOrderDocuments = jobData?.purchaseOrderDocuments ?? []
    this.purchaseOrderNumber = jobData?.purchaseOrderNumber ?? null
    this.assignedEmployeeId = jobData?.assignedEmployeeId ?? null
    this.assignedVehicleId = jobData?.assignedVehicleId ?? null
    this.assignedEquipmentId = jobData?.assignedEquipmentId ?? null
  }
}

export default HaulageJobRequestFormCreate
